<template>
  <div class="d-flex justify-content-between align-items-center">
    <div class="text-gray-800">
      {{ $t('list.page') }}: {{ currentPage }}/{{ totalPages }}
    </div>

    <b-pagination
      v-model="page"
      :total-rows="totalRows"
      :per-page="perPage"
      class="m-0"
      @change="updateList"
    />
  </div>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalRows: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    page: 1
  }),
  computed: {
    totalPages () {
      return Math.ceil(this.totalRows / this.perPage)
    }
  },
  watch: {
    currentPage(page) {
      this.page = page
    }
  },
  methods: {
    updateList (page) {
      this.$emit('change', page)
    }
  }
}
</script>
